import * as $runtime from "../runtime.js";
import * as Data$dFoldable from "../Data.Foldable/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dNullable from "../Data.Nullable/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect$dAff from "../Effect.Aff/index.js";
import * as Halogen$dAff$dDriver from "../Halogen.Aff.Driver/index.js";
import * as Halogen$dVDom$dDOM from "../Halogen.VDom.DOM/index.js";
import * as Halogen$dVDom$dDOM$dProp from "../Halogen.VDom.DOM.Prop/index.js";
import * as Halogen$dVDom$dMachine from "../Halogen.VDom.Machine/index.js";
import * as Halogen$dVDom$dThunk from "../Halogen.VDom.Thunk/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unsafe$dReference from "../Unsafe.Reference/index.js";
import * as Web$dDOM$dNode from "../Web.DOM.Node/index.js";
import * as Web$dHTML from "../Web.HTML/index.js";
import * as Web$dHTML$dWindow from "../Web.HTML.Window/index.js";
const traverse_ = /* #__PURE__ */ Data$dFoldable.traverse_(Effect.applicativeEffect)(Data$dFoldable.foldableMaybe);
const identity = x => x;
const substInParent = v => v1 => v2 => {
  if (v2.tag === "Just") {
    if (v1.tag === "Just") {
      const $0 = Web$dDOM$dNode.insertBefore(v)(v1._1)(v2._1);
      return () => {$0();};
    }
    if (v1.tag === "Nothing") {
      const $0 = Web$dDOM$dNode.appendChild(v)(v2._1);
      return () => {$0();};
    }
  }
  return () => {};
};
const removeChild = v => {
  const $0 = v.node;
  const $1 = Web$dDOM$dNode._parentNode($0);
  return () => {
    const a$p = $1();
    return traverse_(pn => Web$dDOM$dNode.removeChild($0)(pn))(Data$dNullable.nullable(a$p, Data$dMaybe.Nothing, Data$dMaybe.Just))();
  };
};
const mkSpec = handler => renderChildRef => document => (
  {
    buildWidget: spec => {
      const buildThunk = Halogen$dVDom$dThunk.buildThunk(Unsafe$dCoerce.unsafeCoerce)(spec);
      const renderComponentSlot = cs => {
        const renderChild = renderChildRef.value;
        const rsx = renderChild(cs)();
        return Halogen$dVDom$dMachine.$Step$p(
          rsx.node,
          Data$dMaybe.Nothing,
          patch,
          st => {
            if (st.tag === "Just") {
              const $0 = st._1;
              return Halogen$dVDom$dMachine.halt($0);
            }
          }
        );
      };
      const render = slot => {
        if (slot.tag === "ComponentSlot") {
          const $0 = slot._1;
          return renderComponentSlot($0);
        }
        if (slot.tag === "ThunkSlot") {
          const $0 = slot._1;
          const step = buildThunk($0);
          return Halogen$dVDom$dMachine.$Step$p(
            step._1,
            Data$dMaybe.$Maybe("Just", step),
            patch,
            st => {
              if (st.tag === "Just") {
                const $1 = st._1;
                return Halogen$dVDom$dMachine.halt($1);
              }
            }
          );
        }
        $runtime.fail();
      };
      const patch = (st, slot) => {
        if (st.tag === "Just") {
          if (slot.tag === "ComponentSlot") {
            const $0 = slot._1;
            Halogen$dVDom$dMachine.halt(st._1);
            return renderComponentSlot($0);
          }
          if (slot.tag === "ThunkSlot") {
            const $0 = slot._1;
            const step$p = Halogen$dVDom$dMachine.step(st._1, $0);
            return Halogen$dVDom$dMachine.$Step$p(
              step$p._1,
              Data$dMaybe.$Maybe("Just", step$p),
              patch,
              st$1 => {
                if (st$1.tag === "Just") {
                  const $1 = st$1._1;
                  return Halogen$dVDom$dMachine.halt($1);
                }
              }
            );
          }
          $runtime.fail();
        }
        return render(slot);
      };
      return render;
    },
    buildAttributes: Halogen$dVDom$dDOM$dProp.buildProp(handler),
    document
  }
);
const renderSpec = document => container => (
  {
    render: handler => child => v => v1 => {
      if (v1.tag === "Nothing") {
        return () => {
          const renderChildRef = {value: child};
          const machine = Halogen$dVDom$dDOM.buildVDom(mkSpec(handler)(renderChildRef)(document))(v);
          Web$dDOM$dNode.appendChild(machine._1)(container)();
          return {machine, node: machine._1, renderChildRef};
        };
      }
      if (v1.tag === "Just") {
        const $0 = v1._1.machine;
        const $1 = v1._1.node;
        const $2 = v1._1.renderChildRef;
        return () => {
          $2.value = child;
          const a$p = Web$dDOM$dNode._parentNode($1)();
          const a$p$1 = Web$dDOM$dNode._nextSibling($1)();
          const machine$p = Halogen$dVDom$dMachine.step($0, v);
          const $3 = substInParent(machine$p._1)(Data$dNullable.nullable(a$p$1, Data$dMaybe.Nothing, Data$dMaybe.Just))(Data$dNullable.nullable(
            a$p,
            Data$dMaybe.Nothing,
            Data$dMaybe.Just
          ));
          if (!Unsafe$dReference.reallyUnsafeRefEq($1)(machine$p._1)) { $3(); }
          return {machine: machine$p, node: machine$p._1, renderChildRef: $2};
        };
      }
      $runtime.fail();
    },
    renderChild: identity,
    removeChild,
    dispose: removeChild
  }
);
const runUI = component => i => element => Effect$dAff._bind(Effect$dAff._liftEffect(() => {
  const $0 = Web$dHTML.window();
  return Web$dHTML$dWindow.document($0)();
}))(document => Halogen$dAff$dDriver.runUI(renderSpec(document)(element))(component)(i));
export {identity, mkSpec, removeChild, renderSpec, runUI, substInParent, traverse_};
